<template>
    <u-chip-flat-pill v-bind="$attrs" color="primary lighten-5" @click="$emit('click')">
        <span class="primary--text">
            <slot />
        </span>
    </u-chip-flat-pill>
</template>

<script>
import UChipFlatPill from "@/components/publish/styles/chips/u-chip-flat-pill.vue";

export default {
    props: {},
    components: {
        UChipFlatPill,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
